import SoftwareDistribution from "./SoftwareDistribution";

export default class SoftwareDistributionList {
  constructor(name, initialValue, namespace, downloadURLNameSpace, accessURLNameSpace,
      executionLocationNameSpace,
      softwareDistributionFormNameSpace, isEditor = false) {
    this.namespace = namespace;
    this.name = name;
    this.isEditor = isEditor;
    this.downloadURLNameSpace = downloadURLNameSpace;
    this.accessURLNameSpace = accessURLNameSpace;
    this.executionLocationNameSpace = executionLocationNameSpace;
    this.softwareDistributionFormNameSpace = softwareDistributionFormNameSpace;
    this.objList = [];

    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.addValueObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getObjList() {
    return this.objList;
  }

  setObjList(newList) {
    this.objList = newList;
  }

  removeValueObj(item, index) {
    if (index < 0 || index >= this.objList.length) {
      return;
    }
    this.objList.splice(index, 1);
  }

  addValueObj(obj) {
    const distribution = new SoftwareDistribution(this.name, obj, this.namespace, this.downloadURLNameSpace,
        this.accessURLNameSpace, this.executionLocationNameSpace, this.softwareDistributionFormNameSpace, this.isEditor);
    this.objList.push(distribution);
  }

  parseInputJSON(inputJSON) {
    // const obj=inputJSON[this.namespace];
    // console.log("software distribution parse json");
    const obj = inputJSON;
    // console.log(inputJSON, this.namespace);
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.addValueObj(value);
      }
    } else {
      this.addValueObj(obj);
    }
  }

  getExpandedFormatValue() {
    const expandedList = [];
    for (let index = 0; index < this.objList.length; index++) {
      const distributionItem = this.objList[index];
      expandedList.push(distributionItem.getExpandedFormatValue());
    }
    return expandedList;
  }

  isEmpty() {
    let condition = true;
    for (let index = 0; index < this.objList.length; index++) {
      const distributionItem = this.objList[index];
      condition = condition && distributionItem.isEmpty();
    }
    return condition;
  }
}
